import { ProductPrices } from './product-detail';

export type CompareProductShort = {
  productCode: string;
  colorId: number;
};

export type CompareProduct = {
  brand: string;
  collapsedComparePopup?: boolean;
  color: number;
  colorDescription?: string;
  discountPercentage?: number;
  id: number;
  image: string;
  hasDiscount?: boolean;
  prices?: ProductPrices;
  productCode: string;
  selected: boolean;
  size?: string;
  title: string;
  url: string;
  gender?: string;
  buyingGroup?: string;
  productQualifier?: string;
  brandValue?: string;
};

export type CompareProductIdentifier = {
  colorId: number;
  productCode: string;
};

export type CompareFeatureListItem = {
  featureName: string;
  featureType: string;
  featureValue: string;
};

export type ComparisonItem = {
  colourId?: string | number;
  features: Array<Record<string, unknown>>;
  featureList?: Array<CompareFeatureListItem>;
  productId: number;
};

export type ComparisonAttributeTitle = {
  attribute: string;
  title: string;
};

export type ComparisonAttributesAndTitles = {
  items: Array<ComparisonItem>;
  titles: Array<ComparisonAttributeTitle>;
};

export type ComparisonAttributeValues = {
  attribute: string;
  title: string;
  valuesByProducts: Array<string | null>;
};
